import { IHttpClient } from '~/packages/core';

export interface GetRandomPromptsRequest {
    categoriesCount: number;
    itemsPerCategory: number;
}

export interface PromptsLibraryItem {
    category: string;
    content: string;
}

interface GetPromptsResponse {
    items: PromptsLibraryItem[];
}

export class AiPromptsLibraryAdapter {
    protected readonly httpClient: IHttpClient;

    constructor(httpClient: IHttpClient) {
        this.httpClient = httpClient;
    }

    getRandom({ categoriesCount, itemsPerCategory }: GetRandomPromptsRequest) {
        return this.httpClient.request<GetPromptsResponse>({
            method: 'get',
            url: '/api/v2/prompts_library/random',
            params: {
                categories_count: categoriesCount,
                items_per_category: itemsPerCategory
            }
        });
    }

    getAll() {
        return this.httpClient.request<GetPromptsResponse>({
            method: 'get',
            url: '/api/v2/prompts_library'
        });
    }
}
